export enum MenuPopUpEnum {
  orderCustomer = 'orderCustomer',
  orderFromConversation = 'orderFromConversation',
  product = 'product',
  customer = 'customer',
  logistics = 'logistics',
  vendor = 'vendor',
  purchase = 'purchase',
  workOrder = 'workOrder',
  project = 'project',
  task = 'task',
  adjustment = 'adjustment',
}
